var map = {
	"./ADA.svg": 758,
	"./BCH.svg": 759,
	"./BNB.svg": 760,
	"./BTC.svg": 761,
	"./CHZ.svg": 762,
	"./DASH.svg": 763,
	"./DOGE.svg": 764,
	"./DOT.svg": 765,
	"./ETC.svg": 766,
	"./ETH.svg": 767,
	"./EUR.svg": 768,
	"./GBP.svg": 769,
	"./LINK.svg": 770,
	"./LTC.svg": 771,
	"./MATIC.svg": 772,
	"./MKR.svg": 773,
	"./SHIB.svg": 774,
	"./SOL.svg": 775,
	"./TRX.svg": 776,
	"./UNI.svg": 777,
	"./USD.svg": 778,
	"./USDT.svg": 779,
	"./XLM.svg": 780,
	"./XMR.svg": 781,
	"./XRP.svg": 782,
	"./documents.svg": 783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;